/* eslint-disable regex/invalid */
import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/**
 * Only meant for our checkbox component!
 */
export const CheckboxIndeterminate: FC<SvgIconProps> = (props) => (
  <SvgIcon width="20" height="20" {...props}>
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
      fill="currentColor"
    />
    <rect x="7.83334" y="11.1666" width="8.33334" height="1.66667" fill="white" />
  </SvgIcon>
)
